import { render, staticRenderFns } from "./product-attribute-06.vue?vue&type=template&id=0d262a11&"
import script from "./product-attribute-06.vue?vue&type=script&lang=js&"
export * from "./product-attribute-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports